import { render } from "./BrdcmSettingsForm.vue?vue&type=template&id=8fc4ea00&scoped=true&ts=true"
import script from "./BrdcmSettingsForm.vue?vue&type=script&lang=ts"
export * from "./BrdcmSettingsForm.vue?vue&type=script&lang=ts"

import "./BrdcmSettingsForm.vue?vue&type=style&index=0&id=8fc4ea00&scoped=true&lang=css"

import exportComponent from "/builds/vrs/docker/web/app/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8fc4ea00"]])

export default __exports__